import React from "react";
import styled from "styled-components";
import { Link as GatsbyLink } from "gatsby";
import { focusState } from "../tokens/a11y";
import { fancyLinkStyles } from "../tokens/utils";
import { transparentize } from "polished";

const BreadcrumbItem = ({ part, hasSeparator }) => {
  const text = part.href ? (
    <Link to={part.href}>{part.name}</Link>
  ) : (
    <NotLink>{part.name}</NotLink>
  );

  const separator = hasSeparator ? <Separator /> : null;

  return (
    <Item>
      {text}
      {separator}
    </Item>
  );
};

const Breadcrumb = ({ parts, className }) => (
  <BreadcrumbContainer className={className}>
    {parts.map((part, i) => (
      <BreadcrumbItem
        part={part}
        key={part.name + part.href}
        hasSeparator={i < parts.length - 1}
      />
    ))}
  </BreadcrumbContainer>
);

const BreadcrumbContainer = styled.ol`
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 0.75em;
  line-height: 1.4;
`;

const Item = styled.li`
  position: relative;

  display: flex;
  align-items: center;
`;

const Link = styled(GatsbyLink)`
  ${fancyLinkStyles(
    ({ theme }) => transparentize(0.6, theme.palette.lightBlue),
    ({ theme }) => transparentize(0.2, theme.palette.darkerLightBlue)
  )}

  padding-top: 0.125em;
  padding-bottom: 0.125em;
  text-decoration: none;
  color: currentColor;

  &:focus {
    ${focusState(({ theme }) => theme.palette.darkerLightBlue)};
  }
`;

const NotLink = styled.span``;

const Separator = styled.span`
  &::after {
    content: "/";
    margin: 0 0.25em;
  }
`;

export default Breadcrumb;
